export const DEFAULT_FILE_ACCEPTED_TYPES = {
    'image/*': ['.png', '.jpg', '.jpeg', '.tiff', '.tif', '.bmp'],
};

export const DEFAULT_FILE_MAX_SIZE = 5 * 1024 * 1024;

export function formatBytes(bytes: number) {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} kB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

const DEFAULT_DOWNLOAD_FILENAME = 'document';
const MAX_DOWNLOAD_FILENAME_LENGTH = 120;

// Illegal filesystem characters (Windows/POSIX) are replaced with a dash.
const ILLEGAL_FILENAME_CHARS = /[/\\?%*:|"<>]/g;

// Control characters, null bytes, and bidirectional Unicode overrides are
// stripped: a malicious server could inject these into a document description
// to spoof the displayed download filename.
// eslint-disable-next-line no-control-regex
const UNSAFE_CONTROL_CHARS = /[\x00-\x1f\u202a-\u202e\u2066-\u2069]/g;

/**
 * Generates a safe and trimmed suggestion for a file name based on the provided description.
 * Strips control/bidirectional characters, replaces illegal filename characters with dashes,
 * trims whitespace, and limits length.
 * Returns 'document' if the description is not provided or results in an empty name.
 *
 * @param {string | undefined} description - The description to base the file name on.
 * @returns {string} - The suggested, sanitized file name.
 */
export function suggestedDownloadFileName(description: string | undefined): string {
    const base = (description || DEFAULT_DOWNLOAD_FILENAME)
        .replace(UNSAFE_CONTROL_CHARS, '')
        .replace(ILLEGAL_FILENAME_CHARS, '-')
        .trim()
        .slice(0, MAX_DOWNLOAD_FILENAME_LENGTH);
    return base || DEFAULT_DOWNLOAD_FILENAME;
}
